import { Camera } from "@/lib/capacitor/camera";

/** Wat je van de gebruiker nodig hebt om een foto te krijgen: de camera, of zijn fotobibliotheek. */
export type MediaPermission = "camera" | "photos";

/**
 * De uitkomst van het vragen. `blocked` is de enige waar de app zelf niets meer aan kan doen: het
 * systeem heeft de vraag al eens gesteld, het antwoord was nee, en het vraagt het niet nog eens.
 * Daar hoort een weg naar de instellingen bij en geen tweede poging.
 */
export type MediaPermissionResult = "granted" | "blocked";

/**
 * Standen waarin je verder kunt.
 *
 * `limited` is de iOS-stand waarin iemand een paar foto's heeft aangewezen in plaats van zijn hele
 * bibliotheek. Dat is toestemming, alleen kleiner -- de kiezer opent gewoon, met die selectie erin.
 * Hij stond hier niet bij, en dus kreeg wie op iOS bewust voor "selecteer foto's" koos te horen dat
 * hij geen toegang had tot zijn eigen foto's.
 */
const USABLE: ReadonlySet<string> = new Set(["granted", "limited"]);

/**
 * Zorgt dat je mag, en zegt wat er te doen valt als het niet mag.
 *
 * Bewust één plek voor allebei de schermen die een foto vragen (je profielfoto en een bijlage in
 * een gesprek): dit is het soort logica waarvan de twee kopieën stilletjes uit elkaar lopen, en het
 * verschil merk je pas op het toestel van iemand anders.
 */
export async function ensureMediaPermission(
  permission: MediaPermission,
): Promise<MediaPermissionResult> {
  const current = await Camera.checkPermissions();

  if (USABLE.has(current[permission])) {
    return "granted";
  }

  const requested = await Camera.requestPermissions([permission]);

  return USABLE.has(requested[permission]) ? "granted" : "blocked";
}
